import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

/**
 * ⚠️  NO DEVICE SPLIT HERE ANY MORE. This used to load a `Jobs`/`JobsDesktop`
 * pair and choose between them with `useResponsiveness`, which reports `null`
 * on the server — so the page's entire server-rendered output was a loader.
 * `./Jobs` is one responsive page now; see the note at the top of it.
 *
 * Same shape as the careers page's entry, which is the v2 convention.
 */
const AsyncJobs = loadable(() => import("./Jobs"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncJobs {...props} />
  </ErrorBoundary>
);
